import { Navigate, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import { setCanonical } from "@/lib/canonical";

const LegacyRedirect = ({ to }: { to: string }) => {
  const { search, hash } = useLocation();
  useLayoutEffect(() => {
    setCanonical(to);
  }, [to]);
  return <Navigate to={`${to}${search}${hash}`} replace />;
};

export default LegacyRedirect;